import React from 'react';
import Head from 'next/head';
import { getTextFromHtml } from 'utils/transform';

interface IProps {
  event: any;
}

const getMainImageUrl = (images: any[]) => images.find((image: any) => image.main)?.image?.original_url;

const EventMetaTags: React.FC<React.PropsWithChildren<IProps>> = (props) => {
  const { event } = props;
  const imageUrl = Array.isArray(event.images) && getMainImageUrl(event.images);
  return (
    <Head>
      <meta property="og:type" content="events.event" />
      <meta property="og:site_name" content="Jlive" />
      <meta property="og:title" content={event.title} />
      <meta property="og:description" content={getTextFromHtml(event.description)} />
      {imageUrl && (
        <>
          <meta property="og:image" content={imageUrl} />
          <meta property="og:image:alt" content={event.title} />
          <meta name="twitter:image" content={imageUrl} />
          <meta name="twitter:image:alt" content={event.title} />
        </>
      )}
      <meta name="twitter:card" content="summary_large_image" />
    </Head>
  );
};

export default EventMetaTags;
